import React from 'react'

export default ({ children }) => (
  <div style={{ width: '100%', maxWidth: '100%', margin: '0 auto' }}>
    {children}
  </div>
)
